import React, { ReactNode, type CSSProperties, type ElementType, type FC } from "react";
import classes from "./Button.module.scss";
import { Spinner } from "../Spinner";
import cn from "classnames";
interface IButton {
  variant?: "primary" | "secondary" | "outline_primary" | "borderless" | "danger" | "cancel";
  isLoading?: boolean;
  isDisabled?: boolean;
  onClick?: (e?: Event) => void;
  title: string | ReactNode;
  icon?: ReactNode;
  style?: CSSProperties;
  className?: string;
  type?: "button" | "submit" | "reset";
  as?: ElementType;
  id?: string;
}
export const Button: FC<IButton> = ({
  variant = "primary",
  isLoading = false,
  isDisabled = false,
  onClick,
  title,
  icon,
  style,
  className,
  type = "button",
  as: Component = "button",
  id
}) => {
  return <Component id={id} className={cn(classes[variant], {
    [String(className)]: !!className,
    [classes.loading]: isLoading
  })} disabled={isLoading || isDisabled} onClick={onClick} style={{
    ...style
  }} type={type} data-sentry-element="Component" data-sentry-component="Button" data-sentry-source-file="index.tsx">
      {!isLoading ? <>
          <span>{icon}</span>
          <span>{title}</span>
        </> : <Spinner size={"sm"} />}
    </Component>;
};